import { render, staticRenderFns } from "./LoginFormComponent.vue?vue&type=template&id=72d93966&scoped=true&"
import script from "./LoginFormComponent.vue?vue&type=script&lang=js&"
export * from "./LoginFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoginFormComponent.vue?vue&type=style&index=0&id=72d93966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d93966",
  null
  
)

export default component.exports